"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultState = void 0;
exports.sourceReducer = sourceReducer;
var _source = require("../../actions/source");
const defaultState = exports.defaultState = null;
function sourceReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _source.ESourceActionType.Change:
      return action.payload;
  }
  return state;
}